import { render, staticRenderFns } from "./repayment-plan.vue?vue&type=template&id=21a4bdce&scoped=true"
import script from "./repayment-plan.vue?vue&type=script&lang=ts"
export * from "./repayment-plan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4bdce",
  null
  
)

export default component.exports